<app-breadcrumbs title="Item Prices" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5>Item Prices</h5>
        <button class="btn btn-success" (click)="toggleForm()">
          <i [class]="showForm ? 'ri-close-line' : 'ri-add-line'"></i>
          {{ showForm ? 'Cancel' : 'Add Item Price' }}
        </button>
      </div>

      <div *ngIf="showForm" class="card-body border-bottom">
        <form [formGroup]="priceHistoryForm" (ngSubmit)="savePriceHistory()">
          <div class="row g-3">
            <div class="col-md-3">
              <label>Item</label>
              <select formControlName="item_id" class="form-control">
                <option value="">Select Item</option>
                <option *ngFor="let item of items" [value]="item.id">
                  {{ item.name }} ({{ item.unit?.symbol || item.unit_symbol || '-' }})
                </option>
              </select>
            </div>

            <div class="col-md-3">
              <label>Supplier</label>
              <select formControlName="supplier_id" class="form-control">
                <option value="">Select Supplier</option>
                <option *ngFor="let supplier of suppliers" [value]="supplier.id">
                  {{ supplier.name }}
                </option>
              </select>
            </div>

            <div class="col-md-3">
              <label>Price</label>
              <input formControlName="price" type="number" class="form-control" />
            </div>

            <div class="col-md-3">
              <label>Effective Date</label>
              <input formControlName="effective_date" type="date" class="form-control" />
            </div>

            <div class="col-md-6">
              <label>Remarks</label>
              <input formControlName="remarks" class="form-control" />
            </div>
          </div>

          <div class="mt-3 text-end">
            <button class="btn btn-light" type="button" (click)="toggleForm()">Cancel</button>
            <button class="btn btn-success" type="submit">{{ isEditMode ? 'Update' : 'Save' }}</button>
          </div>
        </form>
      </div>

      <div class="card-body" style="overflow: auto;">
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="!isLoading">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th>Item</th>
                <th>Supplier</th>
                <th>Price</th>
                <th>Effective Date</th>
                <th>Remarks</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let history of priceHistories">
                <td>{{ history?.item_name || history?.item?.name }} ({{ history?.unit_symbol || history?.item?.unit?.symbol || '-' }})</td>
                <td>{{ history?.supplier_name || history?.supplier?.name }}</td>
                <td>{{ history?.price | currency:'INR' }}</td>
                <td>{{ history?.effectiveDate | date:'mediumDate' }}</td>
                <td>{{ history?.remarks }}</td>
                <td class="d-flex gap-2">
                  <button class="btn btn-sm btn-success" (click)="editPriceHistory(history)">
                    <i class="ri-edit-2-line"></i>
                  </button>
                  <button class="btn btn-sm btn-danger" (click)="deletePriceHistory(history.id)">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="priceHistories.length > 0 && !isLoading" class="mb-2 row">
          <div class="dataTables_info mb-2 col col-sm-6">
            Showing {{ (page - 1) * pageSize + 1 }}
            to {{ getMin(page * pageSize, totalItems) }}
            of {{ totalItems }} entries
          </div>
          <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
              <ngb-pagination
                [collectionSize]="totalItems"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="changePage($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
